import _ from 'lodash'
import { formatNumber } from 'core/service/lib/number-format'
import { buildHeaderTable } from 'core/service/pdf-generation/utils/builder'
import MESSAGES from 'core/data-model/constants/bi-messages'

const benefitTable = {
  headers: [MESSAGES.BENEFIT_LIST, MESSAGES.BENEFIT_BAHT],
}

export const buildRiderWithPlansBenefitTable = ({ rider, riderBenefitData }) => {
  const benefits = _.get(riderBenefitData, 'benefits')
  return {
    headerRows: 1,
    widths: ['*', 'auto'],
    body: [buildHeaderTable(benefitTable.headers), ...buildContentBenefitTable(benefits, rider)],
  }
}

const buildContentBenefitTable = (benefits, rider) => {
  return benefits.map((benefit, index) =>
    buildBenefitsRow(getSelectedPlanBenefit(benefit, rider.selectedPlan.planCode), index + 1)
  )
}

const buildBenefitsRow = (benefit, rowNumber) => {
  return [
    {
      ol: [benefit.description].map((desc) => ({ text: desc })),
      start: rowNumber,
    },
    { text: formatBenefitValue(benefit.value), alignment: 'right', bold: true },
  ]
}

export const formatBenefitValue = (value) => {
  return isNaN(parseInt(value)) ? value : formatNumber(parseInt(value))
}

export const getSelectedPlanBenefit = (benefit, selectedPlanCode) => {
  const selectedPlanBenefit = _.find(benefit.values, ['planCode', selectedPlanCode])

  return {
    description: benefit.description,
    value: selectedPlanBenefit ? selectedPlanBenefit.value : '',
  }
}
